import React, { useEffect, useState } from 'react';
import {
  BackImg,
  DivForSearchAndRotate,
  FrontImg,
  ImageContainer,
  InputFileLoadingContent,
  InputFileLoadingDocumentInfo,
  InputFileLoadingDocumentInfoContent,
  InputFileLoadingDocumentInfoText
} from './styles';
import { IoClose, IoDocumentTextOutline } from 'react-icons/io5';
import colors from '../../assets/styles/colors';
import marcaAgua from '../../assets/images/background-image.png';
import { FaUndo, FaRedo } from 'react-icons/fa'
import { RiZoomInLine, RiZoomOutFill } from 'react-icons/ri';
const InputFileLoaderPreviewItem = ({ item, removeFile, id }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [rotationDegrees, setRotationDegrees] = useState(0);
  const [widthMA, setWidthMA] = useState(400);
  const [heightMA, setHeightMA] = useState(400);
  const [width, setWidth] = useState(400);
  const [ratio, setRatio] = useState(0);
  const [rotatedHeight, setRotatedHeight] = useState(width);

  const rotateImage = () => {
    setRotationDegrees((prevRotation) => prevRotation + 90);

    const rotatedHeight = width;
    setRotatedHeight(rotatedHeight);
  };

  const zoomImage = () => {
    const newWidth = widthMA + 200;
    const newHeight = heightMA + 200;

    if (newWidth <= 800) {
      setWidthMA(newWidth);
      setHeightMA(newWidth / ratio);
      setWidth(newWidth);
    }
  };

  const backZoomImage = () => {
    const newWidth = widthMA - 200;
    const newHeight = heightMA - 200;

    if (newWidth >= 200) {
      setWidthMA(newWidth);
      setHeightMA(newWidth / ratio);
      setWidth(newWidth);
    }
  };

  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    setTimeout(() => {
      setShowPreview(true)
    }, 2000);
  }, [item])

  useEffect(() => {
    const image = new Image();
    image.src = URL.createObjectURL(item);
    image.onload = () => {
      const baseRatio = image.width / image.height;
      if (width / baseRatio > 500) {
        const maxHeight = 500;
        const newWidth = (maxHeight / image.height) * image.width;
        const ratio2 = newWidth / maxHeight;
        setRatio(ratio2);
        setWidthMA(newWidth);
        setHeightMA(maxHeight);
      } else {
        const ratio2 = image.width / image.height;
        setRatio(image.width / image.height);
        setWidthMA(width);
        setHeightMA(width / ratio2);
      }
    };
    return () => URL.revokeObjectURL(image.src);
  }, []);

  return (
    <InputFileLoadingContent key={id} id="file-preview" onContextMenu={handleContextMenu} rotatedHeight={rotatedHeight}>
      <InputFileLoadingDocumentInfo>
        <InputFileLoadingDocumentInfoContent>
          {showPreview ? <>
            <ImageContainer>
                <img src={URL.createObjectURL(item)} style={{ transform: `rotate(${rotationDegrees}deg)`, width: `${widthMA}px`, height: `${heightMA}px` }}></img><FrontImg src={marcaAgua} style={{ transform: `rotate(${rotationDegrees}deg)`, width: `${widthMA}px`, height: `${heightMA}px` }} ></FrontImg>
            </ImageContainer>
          </>  : <IoDocumentTextOutline color={colors.white} size={60} id="document-text-outline" />}
          
          <DivForSearchAndRotate>
            <InputFileLoadingDocumentInfoText>{item.name}</InputFileLoadingDocumentInfoText>
            <div>
              <FaRedo onClick={rotateImage} style={{ marginRight: '15px' }} />
              <RiZoomInLine size={22} onClick={zoomImage} style={{ marginRight: '15px' }}/>
              <RiZoomOutFill size={22} onClick={backZoomImage}/>
            </div>
          </DivForSearchAndRotate>
          <InputFileLoadingDocumentInfoText>{(item.size / Math.pow(1024, 2)).toFixed(2)} mb</InputFileLoadingDocumentInfoText>
        </InputFileLoadingDocumentInfoContent>
      </InputFileLoadingDocumentInfo>
      {<IoClose color={colors.white} size={22} onClick={() => removeFile(id)} id="close-icon" />}
    </InputFileLoadingContent>
  )
}

export default InputFileLoaderPreviewItem
